/**
 * Magazine-Related Routes
 *
 * Routes for news, magazine landing, and magazine categories (AI, Design, Law)
 */

import React from "react";
import { Route } from "react-router-dom";
import { ArticleRouter, MagazinePage } from "../lazyComponents";
import { getCommonProps } from "./routeConfig";

/**
 * Creates article routes for a specific category
 * @param {string} category - The article category
 * @param {string} basePath - The base path for the routes
 * @param {Object} componentProps - Props to pass to components
 * @returns {Array} Array of Route elements
 */
const createArticleRoutes = (category, basePath, componentProps) => [
  <Route
    key={`${basePath}-list`}
    path={basePath}
    element={
      <ArticleRouter
        category={category}
        {...componentProps}
        {...getCommonProps()}
      />
    }
  />,
  <Route
    key={`${basePath}-detail`}
    path={`${basePath}/:articleSlug`}
    element={
      <ArticleRouter
        category={category}
        {...componentProps}
        {...getCommonProps()}
      />
    }
  />,
];

/**
 * Gets all magazine-related routes
 * @param {Object} props - Props from parent component
 * @returns {Array} Array of Route elements
 */
export const getMagazineRoutes = ({
  getComponentProps,
  getHeaderStyleProps,
}) => {
  const componentProps = getComponentProps();
  const headerStyleProps = getHeaderStyleProps();

  return [
    // News routes
    ...createArticleRoutes("News", "/news", componentProps),

    // Magazine landing page
    <Route
      key="magazine-landing"
      path="/magazine"
      element={<MagazinePage {...headerStyleProps} {...getCommonProps()} />}
    />,

    // TadReamk AI routes
    ...createArticleRoutes("TadReamk AI", "/magazine/ai", componentProps),

    // TadReamk Design routes
    ...createArticleRoutes(
      "TadReamk Design",
      "/magazine/design",
      componentProps,
    ),

    // IP Law routes
    ...createArticleRoutes("IP Law", "/magazine/law", componentProps),

    // TadReamk-AIGC routes
    ...createArticleRoutes("TadReamk-AIGC", "/magazine/aigc", componentProps),

    // TadReamk-ERP routes
    ...createArticleRoutes("TadReamk-ERP", "/magazine/erp", componentProps),
  ];
};
